import { z } from 'zod';

import { isoDatetimeToDate } from '../codecs';
import { SessionType } from './session-type';

export type SessionMetadata = z.output<typeof sessionMetadataSchema>;
export type SessionMetadataDTO = z.input<typeof sessionMetadataSchema>;

export const sessionMetadataSchema = z.object({
  createdAt: isoDatetimeToDate,
  description: z.string().optional(),
  sessionId: z.uuid(),
  title: z.string().optional(),
  type: z.enum(SessionType),
  updatedAt: isoDatetimeToDate,
});
